import { Injectable } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { CommonService } from '../../shared/services/common.service';
export const headerOptions = {responseType : 'text' as 'json'}

@Injectable({
  providedIn: 'root',
})
export class BulkServiceService {
  rfqCartId;
  // bulkEntryObj = {
  //   brandCode: 'Masoneilan',
  //   brandName: 'Masoneilan',
  //   comment: '',
  //   customerRequestedDate: new Date(Date.now())
  //     .toISOString()
  //     .slice(0, 19)
  //     .replace(/-/g, '/')
  //     .split('T')[0],
  //   productType: 'Part',
  //   quantity: productItem.quantity || 1,
  //   reasonForQuote: 'Prices and Services',
  //   rfqPartDescription: productItem.product.name,
  //   rfqPartNumber: productItem.product.code
  // };
  public getOrderBulk = new BehaviorSubject(null);
  recieveOrderId = this.getOrderBulk.asObservable();

  public getFailCount = new BehaviorSubject(null);
  recieveCount = this.getFailCount.asObservable();

  public getSucArr = new BehaviorSubject(null);
  recieveSucArr = this.getSucArr.asObservable();

  public getSucFlag = new BehaviorSubject(null);
  recieveSucFlag = this.getSucFlag.asObservable();

  public showDate = new BehaviorSubject(null);
  showDateEmitted$ = this.showDate.asObservable();

  public showFileType = new BehaviorSubject(null);
  showFileTypeEmitted$ = this.showFileType.asObservable();

  priceNotAvailableinSAPProducts = new BehaviorSubject([]);

  public contentData = new BehaviorSubject(null);
  getContent = this.contentData.asObservable();

  public newCartId = new BehaviorSubject(false);

  public vsntriesCart = new BehaviorSubject(false);

  public buyPLPCart = new BehaviorSubject(false);

  public newQuoteId = new BehaviorSubject(false);

  public addQuoteId = new BehaviorSubject(false);

  public quoteCheckoutId = new BehaviorSubject(false);

  public bulkQuoteCartId = new BehaviorSubject(false);

  public quoteDialogId = new BehaviorSubject(false);

  public productQuoteDialog = new BehaviorSubject(false);

  public requestQuoteDialog = new BehaviorSubject(false);


  constructor(private auth: AuthService, public commonService: CommonService) {
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.rfqCartId = sessionStorage.getItem('cartId-current');
      } else {
        this.rfqCartId = sessionStorage.getItem('cartId-anonymous');
      }
    });
  }
  getBulkOrderList(userType) {
    const urlparams = [
      'users',
      userType,
      'bulkOrders',
      'downloadSampleTemplate',
    ];
    const apiUrl = this.commonService.constructUrl(urlparams);
    return this.commonService.getData(apiUrl, headerOptions);
  }

  getBulkCopyPasteList(bulkList, userType) {
    const urlparams = ['users', userType, 'bulkOrders', 'copyPasteUpload'];
    const apiUrl = this.commonService.constructUrl(urlparams);
    return this.commonService.postData(apiUrl, bulkList);
  }
  successFlag: any;
  bulkCode: any;
  failCount: any;
  successBulkArr: any;

  //   sendhideSuccess(valid : any){
  // this.getSucFlag.next(valid);
  //   }
  gethideSuccess() {
    return this.successFlag;
  }
  sendBulkOrderList(valid: any) {
    //  this.bulkCode = valid;
    this.getOrderBulk.next(valid);
  }
  sendFailureCount(valid: any) {
    this.getFailCount.next(valid);
  }
  sendSuccessArr(valid: any) {
    this.getSucArr.next(valid);
  }
  getSuccessArr() {
    return this.successBulkArr;
  }
  getFailureCount() {
    return this.failCount;
  }
  getBulkCode() {
    return this.bulkCode;
  }
  // getBulkConfirmObj(){
  //   const urlparams = ['users', 'current', 'carts', this.getBulkOrderCartCode, 'bomEntries'];
  //   const apiUrl = this.commonService.constructUrl(urlparams);
  // }
  // goToQuote(){
  //   const urlparams = ['users', 'current', 'rfqcart',this.rfqCartId, 'bomRfqEntries'];
  //   const apiUrl = this.commonService.constructUrl(urlparams);
  //   return this.commonService.postData(apiUrl,this.bulkEntryObj)
  // }

  emitDate(flag) {
    this.showDate.next(flag);
  }
  emitFileType(type) {
    this.showFileType.next(type);
  }
  setContent(content) {
    this.contentData.next(content);
  }
}
